import SubSection from './SubSection.view';
import { MATERIAL_TYPES, MATERIAL_TYPES_ICON, MATERIAL_TYPES_STRING } from './util';

export { MATERIAL_TYPES, MATERIAL_TYPES_ICON, MATERIAL_TYPES_STRING };

export default SubSection;
